import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import en from 'element-plus/es/locale/lang/en';

export const elLocaleMap = {
    'zh-CN': zhCn,
    en: en,
};

export enum LocaleTypeEnum {
    English = 'en',
    Chinese = 'zh-CN',
}

export type LocaleType = 'zh-CN' | 'en'; //语言类型

export interface LocaleOptionType {
    // 语言配置选项
    value: LocaleType;
    label?: string;
}

const LOCALE_STORAGE_KEY = 'flagos-locale';

/** 进入登录页前保存的语言，用于 401 等清空 storage 后登录页恢复语言 */
export const LOCALE_BEFORE_LOGIN_KEY = 'flagos_locale_before_login';

// 从 localStorage 获取保存的语言设置（优先用主 key，其次用进入登录前记录的 key）
const getStoredLocale = (): LocaleTypeEnum => {
    try {
        let stored = localStorage.getItem(LOCALE_STORAGE_KEY);
        if (stored === LocaleTypeEnum.English || stored === LocaleTypeEnum.Chinese) {
            return stored;
        }
        stored = localStorage.getItem(LOCALE_BEFORE_LOGIN_KEY);
        if (stored === LocaleTypeEnum.English || stored === LocaleTypeEnum.Chinese) {
            localStorage.setItem(LOCALE_STORAGE_KEY, stored);
            return stored;
        }
    } catch (e) {
        console.warn('Failed to read locale from localStorage:', e);
    }
    return LocaleTypeEnum.Chinese;
};

const useLocaleStore = defineStore('locales', () => {
    const currentLocale = ref<LocaleTypeEnum>(getStoredLocale());
    const localeOption = ref<LocaleOptionType[]>([
        {
            value: 'zh-CN',
            label: '中文',
        },
        {
            value: 'en',
            label: 'English',
        },
    ]);

    const isChinese = computed(() => currentLocale.value === LocaleTypeEnum.Chinese);
    const getCurrentLocale = computed(() => currentLocale.value);
    const getLocaleOption = computed(() => localeOption.value);

    function setCurrentLocale(localeType: LocaleTypeEnum) {
        currentLocale.value = localeType;
        // 持久化到 localStorage
        try {
            localStorage.setItem(LOCALE_STORAGE_KEY, localeType);
        } catch (e) {
            console.warn('Failed to save locale to localStorage:', e);
        }
    }

    return {
        currentLocale,
        localeOption,
        isChinese,
        getCurrentLocale,
        getLocaleOption,
        setCurrentLocale,
    };
});

export default useLocaleStore;
